/**
 * Primary product keys represent products that can mount Search Page.
 */
export const PrimaryProductKeys = {
	Atlas: 'townsquare',
	Confluence: 'confluence',
	Assets: 'cmdb',
	Focus: 'mercury',
	Jira: 'jira',
	Elevate: 'elevate',
	Talent: 'radar',
	RovoExtension: 'rovo-extension',
	Studio: 'studio',
	Loom: 'loom',
} as const;
